// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpSharenodemgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpSharenodemgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpSharenodemgrIconOutlined = function DrrpSharenodemgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpSharenodemgrIconOutlinedSvg
  }));
};

DrrpSharenodemgrIconOutlined.displayName = 'DrrpSharenodemgrIconOutlined';
export default React.forwardRef(DrrpSharenodemgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpSharenodemgrIconOutlined.js
// module id = 2573
// module chunks = 0